/**
 * Jediný zdroj pravdy pro identifikační a kontaktní údaje společnosti.
 * Hodnoty vycházejí z ověřených údajů původního webu a zadání (sekce 4).
 */
export const siteConfig = {
  name: "GP tax consulting s.r.o.",
  shortName: "GP tax consulting",
  legalName: "GP tax consulting s.r.o.",
  url: "https://www.dane-a-ucetnictvi.eu",
  locale: "cs_CZ",
  lang: "cs",
  tagline: "Daňové a účetní poradenství v Opavě",
  description:
    "Daňové poradenství, vedení účetnictví a zpracování mezd pro malé a střední firmy a OSVČ v Opavě a na severní Moravě.",
  contact: {
    email: "poradcegrafova@volny.cz",
    phone: "+420553612851",
    phoneDisplay: "+420 553 612 851",
    mobile: "+420777612851",
    mobileDisplay: "+420 777 612 851",
    hours: "8:00–14:00",
    hoursNote: "Pondělí až pátek",
  },
  address: {
    street: "Sadová 121/4",
    city: "746 01 Opava Předměstí",
    country: "Česká republika",
    full: "Sadová 121/4, 746 01 Opava Předměstí",
  },
  legal: {
    companyId: "01988875",
    vatId: "CZ01988875",
    legalForm: "Společnost s ručením omezeným",
    register: "C 57058, vedená u Krajského soudu v Ostravě",
    dataBox: "59iy7m8",
    bankAccount: "2400465455/2010",
  },
} as const;

export type SiteConfig = typeof siteConfig;
